module.exports = __webpack_public_path__ + "public/img/tmmpt.cdc770f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tmmpt.png
// module id = sAt/
// module chunks = 1